import Immutable from 'immutable';
import {i18n} from '../services/i18n';

import {DISMISS_NOTIFICATION} from '../actions/notifications';
import {
  LOGIN_ERROR,
  INVALID_CREDENTIALS_ERROR,
  NO_ACTIVE_CAMPAIGN_ERROR,
  AUTH_EXPIRED_ERROR,
  PASSWORD_RESET_SUCCESS,
  PASSWORD_RESET_ERROR,
  NEW_PASSWORD_SETTING_SUCCESS,
  PASSWORD_MISSING_SYMBOLS,
  PASSWORD_MISSING_LETTERS,
  PASSWORD_MISSING_NUMBERS,
  PASSWORD_MISSING_MIXEDCASE,
  PASSWORD_COMPROMISED,
  NEW_PASSWORD_SETTING_ERROR,
  PASSWORD_VALIDATION_ERROR,
} from '../actions/login';
import {EVALUATION_SAVING_ERROR} from '../actions/evaluationQuestions';

import {OFFLINE_ERROR, TIMEOUT_ERROR} from '../services/errors';

const initialState = Immutable.OrderedSet();

export default function (state = initialState, action) {
  if (action.noNotification && action.type !== DISMISS_NOTIFICATION) {
    return state;
  }

  let newState;

  switch (action.type) {
    case DISMISS_NOTIFICATION:
      return state.filter(n => n.key !== action.notification.key);
    case OFFLINE_ERROR:
      newState = state.filter(n => n.key !== 'network');

      return newState.add({
        title: `${i18n._('notifications.offline_error_title', {}, {defaults: 'Sei offline'})}:`,
        message: i18n._(
          'notifications.offline_error_message',
          {},
          {defaults: "Non posso eseguire l'operazione senza connessione"}
        ),
        key: 'network',
        dismissAfter: 3000,
      });
    case TIMEOUT_ERROR:
      newState = state.filter(n => n.key !== 'network');

      return newState.add({
        title: `${i18n._(
          'notifications.timeout_error_title',
          {},
          {defaults: 'Ci sono problemi con la connessione'}
        )}:`,
        message: i18n._(
          'notifications.timeout_error_message',
          {},
          {defaults: 'Riprova più tardi per piacere'}
        ),
        key: 'network',
        dismissAfter: 3000,
      });

    case LOGIN_ERROR:
      newState = state.filter(n => n.key !== 'login');

      return newState.add({
        title: `${i18n._(
          'notifications.login_error_title',
          {},
          {defaults: 'Qualcosa non ha funzionato'}
        )}:`,
        message: i18n._(
          'notifications.login_error_message',
          {},
          {defaults: 'Impossibile verificare le credenziali'}
        ),
        key: 'login',
        dismissAfter: 3000,
      });

    case INVALID_CREDENTIALS_ERROR:
      newState = state.filter(n => n.key !== 'invalid_credentials');

      return newState.add({
        title: `${i18n._(
          'notifications.invalid_credentials_error_title',
          {},
          {defaults: 'Qualcosa non ha funzionato'}
        )}:`,
        message: i18n._(
          'notifications.invalid_credentials_error_message',
          {},
          {defaults: 'Le credenziali sono errate'}
        ),
        // title: 'Non riesco a riconoscere questo utente',
        // message: `per piacere, ricontrolla le credenziali inserite' : ''}`,
        key: 'invalid_credentials',
        dismissAfter: 3000,
      });

    case NO_ACTIVE_CAMPAIGN_ERROR:
      newState = state.filter(n => n.key !== 'no_active_campaign_for_user');

      return newState.add({
        title: `${i18n._(
          'notifications.no_active_campaign_error_title',
          {},
          {defaults: 'Qualcosa non ha funzionato'}
        )}:`,
        message: i18n._(
          'notifications.no_active_campaign_error_message',
          {},
          {defaults: 'Nessuna campagna attiva'}
        ),
        key: 'no_active_campaign_for_user',
        dismissAfter: 3000,
      });

    case AUTH_EXPIRED_ERROR:
      newState = state.filter(n => n.key !== 'auth');

      return newState.add({
        title: i18n._(
          'notifications.auth_expired_error_title',
          {},
          {defaults: 'Per piacere, esegui di nuovo il login'}
        ),
        message: '',
        key: 'auth',
        dismissAfter: 3000,
      });
    case PASSWORD_RESET_SUCCESS:
      newState = state.filter(n => n.key !== 'passwordReset');

      return newState.add({
        title: '',
        message: i18n._(
          'notifications.password_reset_success_message',
          {},
          {
            defaults:
              "Se l'indirizzo email inserito è corretto riceverai una email con le istruzioni per procedere al reset",
          }
        ),
        key: 'passwordReset',
        dismissAfter: 6000,
      });
    case PASSWORD_RESET_ERROR:
      newState = state.filter(n => n.key !== 'passwordReset');

      return newState.add({
        title: `${i18n._(
          'notifications.password_reset_error_title',
          {},
          {defaults: "C'è stato un errore nell'invio della richiesta"}
        )}:`,
        message: i18n._(
          'notifications.password_reset_error_message',
          {},
          {defaults: "Controlla l'indirizzo inserito"}
        ),
        key: 'passwordReset',
        dismissAfter: 3000,
      });
    case NEW_PASSWORD_SETTING_SUCCESS:
      newState = state.filter(n => n.key !== 'newPassword');

      return newState.add({
        title: i18n._(
          'notifications.new_password_setting_success_title',
          {},
          {defaults: 'Password modificata con successo'}
        ),
        message: '',
        key: 'newPassword',
        dismissAfter: 3000,
      });
    case PASSWORD_MISSING_SYMBOLS:
      newState = state.filter(n => n.key !== 'passwordMissingSymbols');

      return newState.add({
        title: i18n._(
          'notifications.new_password_validation_error_title',
          {},
          {defaults: 'Password validation error :'}
        ),
        message: i18n._(
          'notifications.new_password_validation_missing_symbols',
          {},
          {defaults: 'must contain at least one symbol, please, choose a new one'}
        ),
        key: 'passwordMissingSymbols',
        dismissAfter: 3000,
      });
    case PASSWORD_MISSING_LETTERS:
      newState = state.filter(n => n.key !== 'passwordMissingLetters');

      return newState.add({
        title: i18n._(
          'notifications.new_password_validation_error_title',
          {},
          {defaults: 'Password validation error :'}
        ),
        message: i18n._(
          'notifications.new_password_validation_missing_letters',
          {},
          {defaults: 'must contain at least one letter, please, choose a new one'}
        ),
        key: 'passwordMissingLetters',
        dismissAfter: 3000,
      });
    case PASSWORD_MISSING_NUMBERS:
      newState = state.filter(n => n.key !== 'passwordMissingNumbers');

      return newState.add({
        title: i18n._(
          'notifications.new_password_validation_error_title',
          {},
          {defaults: 'Password validation error :'}
        ),
        message: i18n._(
          'notifications.new_password_validation_missing_numbers',
          {},
          {defaults: 'must contain at least one number, please, choose a new one'}
        ),
        key: 'passwordMissingNumbers',
        dismissAfter: 3000,
      });
    case PASSWORD_MISSING_MIXEDCASE:
      newState = state.filter(n => n.key !== 'passwordMissingMixedCase');

      return newState.add({
        title: i18n._(
          'notifications.new_password_validation_error_title',
          {},
          {defaults: 'Password validation error :'}
        ),
        message: i18n._(
          'notifications.new_password_validation_mixedcase',
          {},
          {
            defaults:
              'must contain at least one uppercase and one lowercase letter, please, choose a new one',
          }
        ),
        key: 'passwordMissingMixedCase',
        dismissAfter: 3000,
      });
    case PASSWORD_COMPROMISED:
      newState = state.filter(n => n.key !== 'passwordCompromised');

      return newState.add({
        title: i18n._(
          'notifications.new_password_validation_error_title',
          {},
          {defaults: 'Password validation error :'}
        ),
        message: i18n._(
          'notifications.new_password_validation_compromised',
          {},
          {defaults: 'please, choose a more complex one'}
        ),
        key: 'passwordCompromised',
        dismissAfter: 3000,
      });
    case NEW_PASSWORD_SETTING_ERROR:
      newState = state.filter(n => n.key !== 'newPassword');

      return newState.add({
        title: i18n._(
          'notifications.new_password_setting_error_title',
          {},
          {defaults: 'Non è possibile modificare la password'}
        ),
        message: '',
        key: 'newPassword',
        dismissAfter: 3000,
      });
    case PASSWORD_VALIDATION_ERROR:
      newState = state.filter(n => n.key !== 'passwordValidation');

      return newState.add({
        title: action.message,
        message: '',
        key: 'passwordValidation',
        dismissAfter: 3000,
      });
    case EVALUATION_SAVING_ERROR:
      newState = state.filter(n => n.key !== 'evaluationSavingError');

      return newState.add({
        title: action.message,
        message: '',
        key: 'evaluationSavingError',
        dismissAfter: 3000,
      });
    case 'GENERAL_ERROR': {
      newState = state.filter(n => n.key !== action.key);

      return newState.add({
        title: action.message,
        message: '',
        key: action.key,
        dismissAfter: action.dismissAfter || 3000,
      });
    }
    default:
      return state;
  }
}

/* Selectors */

export function getNotifications(state) {
  return state.get('notifications');
}
